import axios from "axios";
import { useUserStore } from "@/stores/UserStore";
import { getKeycloak } from "@/plugins/keycloak";

const apiClient = axios.create({
  baseURL: window.VUE_APP_MISTRA_URL,
  timeout: 30000,
});

apiClient.interceptors.request.use((config) => {
  const user = useUserStore();
  const token = user.token || getKeycloak()?.idToken;
  config.headers["Accept"] = "application/json";
  config.headers["Authorization"] = "Bearer " + token;
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    error.userMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Undefined Error";
    return Promise.reject(error);
  }
);

/** Valida e restituisce i parametri obbligatori. Lancia errore se un valore è mancante. */
export function requiredParams(obj = {}) {
  Object.entries(obj).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") {
      throw new Error(`Parametro obbligatorio mancante: ${key}`);
    }
  });
  return obj;
}

/** Restituisce solo i parametri con valore (esclude null/undefined/""). */
export function optionalParams(obj = {}) {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
  );
}

export default apiClient;
